import actions from './actions';

const {
  CLAIM_REPORT_LIST_BEGIN,
  CLAIM_REPORT_LIST_SUCCESS,
  CLAIM_REPORT_LIST_ERR,
} = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const claimReportReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CLAIM_REPORT_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CLAIM_REPORT_LIST_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case CLAIM_REPORT_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default claimReportReducer;
